
import { DateRangeType } from "@/components/admin/DateRangeFilter";
import { subDays } from "date-fns";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const getAdminStats = async (dateRange: DateRangeType) => {
  try {
    console.log('Fetching admin stats with date range:', dateRange);
    
    // Fetch real data from GA4 via our Edge Function
    const { data, error } = await supabase.functions.invoke('get-analytics-data', {
      body: { dateRange }
    });

    if (error) {
      console.error('Error invoking get-analytics-data edge function:', error);
      throw new Error(`Edge function error: ${error.message}`);
    }

    if (!data) {
      console.error('No data returned from edge function');
      throw new Error('No data returned from analytics function');
    }

    console.log('Received admin stats:', data);

    // Check if there's an error in the data
    if (data.error) {
      console.error('Error returned in edge function response:', data.error);
      throw new Error(`Analytics error: ${data.error}`);
    }

    return {
      totalUsers: data.totalUsers,
      totalCourses: data.totalCourses,
      totalRevenue: data.totalRevenue,
      liveVisitors: data.liveVisitors || 0,
      timeSeriesData: data.timeSeriesData
    };
  } catch (err) {
    console.error('Error fetching admin stats:', err);
    toast.error(`Could not fetch analytics data: ${err.message}`);
    throw err; // Re-throw to allow component error handling
  }
};

export const getLiveVisitorsCount = async () => {
  try {
    const { data, error } = await supabase.functions.invoke('get-analytics-data', {
      body: { requestType: 'liveVisitors' }
    });

    if (error) {
      console.error('Error fetching live visitors:', error);
      throw error;
    }

    if (!data) {
      throw new Error('Failed to fetch live visitors');
    }

    // If there's an error in the data response, log it but return 0
    if (data.error) {
      console.error('Error in live visitors data:', data.error);
      toast.error(`Live visitor data error: ${data.error}`);
      return 0;
    }

    return data.liveVisitors || 0;
  } catch (err) {
    console.error('Error fetching live visitors:', err);
    toast.error(`Could not fetch live visitor data: ${err.message}`);
    return 0; // Return 0 instead of throwing to avoid breaking the UI
  }
};
